/**
 * Instance Theme — coaching dashboard
 * Kinetic Ledger gold accent system
 */

const CREIGHTON_ACCENT = {
  gold: '#FED603',
  goldMuted: '#e8c200',
  goldDim: '#4A3900',
  goldLight: '#ffe16d',
  goldRgb: '254, 214, 3',
  g15: 'rgba(254, 214, 3, 0.15)',
  g08: 'rgba(254, 214, 3, 0.08)',
};

export function getBrandInstance() {
  return 'creighton';
}

export function getBrandAccent() {
  return CREIGHTON_ACCENT;
}
